import { UI_LogoList } from 'ui/components/3-organisms/LogoList/LogoList';

export const LogoListFeature: React.FC<Content.LogoList> = ({ content }) => {
	return (
		<UI_LogoList
			bgColor={content?.properties?.color}
			heading={content?.properties?.heading}
			logoAndLinkList={content?.properties?.logoAndLinkList?.map(
				({
					content: {
						properties: { link, logo },
					},
				}) => ({
					link: {
						href: link?.url,
						text: link?.name,
						target: link?.target,
					},
					logo: {
						url: logo?.url,
						altText: logo?.properties?.altText,
						fileType: logo?.properties?.umbracoExtension,
					},
				}),
			)}
			trumpetHeading={content?.properties?.trumpetHeading}
		/>
	);
};
